import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerReview = () => {
  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get('/api/seller/review-data', {
        withCredentials: true,
      });

      if (res.data && res.data.ok) {
        setShopName(res.data.shop_name || '');
        setReviews(Array.isArray(res.data.reviews) ? res.data.reviews : []);
      } else {
        alert(res.data?.error || '리뷰 목록을 불러오지 못했습니다.');
      }
    } catch (err) {
      const redirect = err?.response?.data?.redirect;
      const error = err?.response?.data?.error;
      if (redirect) {
        window.location.href = redirect;
        return;
      }
      alert(error || '리뷰 목록을 불러오지 못했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (reviewId) => {
    const ok = window.confirm('정말 삭제하시겠습니까?');
    if (!ok) return;

    try {
      const res = await axios.post(
        '/api/seller/review/delete-json',
        { delete_id: reviewId },
        { withCredentials: true }
      );

      if (res.data && res.data.ok) {
        setReviews((prev) => prev.filter((row) => row.id !== reviewId));
      } else {
        alert(res.data?.error || '삭제에 실패했습니다.');
      }
    } catch (err) {
      alert(err?.response?.data?.error || '삭제에 실패했습니다.');
    }
  };

  const renderStars = (rating) => {
    const r = Number(rating || 0);
    return `${'★'.repeat(r)}${'☆'.repeat(5 - r)}`;
  };

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loading}>로딩중...</div>
      </SellerLayout>
    );
  }

  return (
    <SellerLayout shopName={shopName}>
      <div style={styles.container}>
        <h2 style={styles.title}>리뷰 관리 ({shopName})</h2>

        <div style={styles.tableWrap}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>상품명</th>
                <th style={styles.th}>작성자</th>
                <th style={styles.th}>별점</th>
                <th style={styles.th}>내용</th>
                <th style={styles.th}>이미지</th>
                <th style={styles.th}>작성일</th>
                <th style={styles.th}>관리</th>
              </tr>
            </thead>
            <tbody>
              {reviews.length > 0 ? (
                reviews.map((row) => (
                  <tr key={row.id}>
                    <td style={styles.td}>{row.product_name}</td>
                    <td style={styles.td}>{row.nickname}</td>
                    <td style={styles.td}>
                      <span style={styles.starText}>{renderStars(row.rating)}</span>
                    </td>
                    <td style={styles.contentTd}>
                      {row.content || ''}
                    </td>
                    <td style={styles.td}>
                      {row.image_url ? (
                        <img
                          src={row.image_url}
                          style={styles.thumb}
                          alt="리뷰 이미지"
                        />
                      ) : null}
                    </td>
                    <td style={styles.td}>{row.created_at}</td>
                    <td style={styles.td}>
                      <button
                        type="button"
                        style={styles.deleteBtn}
                        onClick={() => handleDelete(row.id)}
                      >
                        삭제
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} style={styles.emptyTd}>
                    등록된 리뷰가 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </SellerLayout>
  );
};

const styles = {
  loading: { padding: '40px 0' },
  container: { marginTop: '16px' },
  title: { marginBottom: '24px' },
  tableWrap: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
  th: {
    border: '1px solid #dee2e6',
    padding: '12px',
    background: '#f8f9fa',
    fontWeight: 600,
    verticalAlign: 'middle',
  },
  td: {
    border: '1px solid #dee2e6',
    padding: '12px',
    verticalAlign: 'middle',
  },
  contentTd: {
    border: '1px solid #dee2e6',
    padding: '12px',
    verticalAlign: 'middle',
    whiteSpace: 'pre-line',
    maxWidth: '300px',
    textAlign: 'left',
  },
  thumb: {
    width: '80px',
    height: 'auto',
  },
  starText: {
    color: '#ffc107',
  },
  deleteBtn: {
    border: 'none',
    background: '#dc3545',
    color: '#fff',
    padding: '6px 10px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '12px',
  },
  emptyTd: {
    border: '1px solid #dee2e6',
    padding: '24px',
    color: '#6c757d',
  },
};

export default SellerReview;